export default __webpack_public_path__ + "static/media/DoOver_159x150.45115b68.png";